import React, { useCallback, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

import { FixedContainer } from "components";
import { SetMatchDataType } from "types";

import styles from "./pageSearch.module.scss";

type PageSearchInputProps = {
	placeholderText?: string;
	setSearchString: (value: string) => void;
	setMatchDataFn: (fn: SetMatchDataType) => void;
};

const PageSearchInput = ({
	placeholderText = "Search Notifications",
	setSearchString,
	setMatchDataFn,
}: PageSearchInputProps) => {
	const [totalMatchCount, setTotalMatchCount] = useState<number>(0);
	const [sectionElements, setSectionElements] = useState<
		(HTMLDivElement | null)[]
	>([]);
	const [focusIndex, setFocusIndex] = useState<number>(-1);

	const initMatchData = useCallback((): SetMatchDataType => {
		const matchCountInWrappers: number[] = [];

		return (componentIndex, count, sectionElement) => {
			matchCountInWrappers[componentIndex] = count;
			setTotalMatchCount(
				matchCountInWrappers.reduce(
					(accumulator, current) => accumulator + current,
				),
			);

			setSectionElements(prevState => {
				const newState = [
					...(prevState as Array<HTMLDivElement | null>),
				];
				newState[componentIndex] = sectionElement;
				return newState;
			});
		};
	}, []);

	useEffect(() => {
		setMatchDataFn(() => initMatchData());
	}, [initMatchData, setMatchDataFn]);

	const handleKeyUp = useCallback(
		e => {
			setSearchString(e?.target?.value);
		},
		[setSearchString],
	);

	const handleKeyDown = useCallback(
		e => {
			if (e.key === "Enter") {
				for (let i = focusIndex + 1; i < sectionElements.length; i++) {
					if (sectionElements[i]) {
						sectionElements[i]?.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});
						setFocusIndex(
							i === sectionElements.length - 1 ? -1 : i,
						);
						break;
					}
				}
			}
		},
		[focusIndex, sectionElements],
	);

	return (
		<FixedContainer>
			<Row className={styles.container}>
				<Col sm="3">
					<Form.Control
						className={styles.input}
						placeholder={placeholderText}
						onKeyUp={handleKeyUp}
						onKeyDown={handleKeyDown}
					/>
				</Col>
				<Col sm="4" className={styles.counter}>
					{totalMatchCount || 0} match
				</Col>
			</Row>
		</FixedContainer>
	);
};

export default PageSearchInput;
